import { render, staticRenderFns } from "./SidebarSearch.vue?vue&type=template&id=0cbda5c5&scoped=true"
import script from "./SidebarSearch.vue?vue&type=script&lang=js"
export * from "./SidebarSearch.vue?vue&type=script&lang=js"
import style0 from "./SidebarSearch.vue?vue&type=style&index=0&id=0cbda5c5&prod&lang=scss&scoped=true"
import style1 from "./SidebarSearch.vue?vue&type=style&index=1&id=0cbda5c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbda5c5",
  null
  
)

export default component.exports